module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "label1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2"
    }
  }), _c('strong', [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "h3a"
  }, [_c('strong', [_vm._v("JIM CROW’S TRIUMPH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As white hostility almost closed the housing market to Negroes and created a physical ghetto, it also limited the opportunities for Negroes to secure desirable jobs and gain access to public facilities. Chicago Negroes in the early twentieth century were confined to the domestic and personal service trades and were unable to gain even a foothold in industry and commerce. In 1900, almost 65 per cent of the Negro men and over 80 per cent of the Negro women worked as domestic and personal servants, while only 8.3 per cent of the men and 11.9 per cent of the women were engaged in manufacturing (and most of the women so employed worked in their own homes as dressmakers and seamstresses). In 1910 the basic pattern remained the same. Over 45 per cent of the employed Negro men worked in just four occupations—as porters, servants, waiters, and janitors—and over 63 per cent of the women were domestic servants or laundresses. In both 1900 and 1910, more Negroes were engaged in the professions than their numbers would warrant, but these were concentrated in professions that required relatively little formal training—music, the theater, and the clergy. Relatively few Negroes could be found in the legal, medical, and teaching professions. A large portion of those Negroes employed in manufacturing, trade, and transportation were unskilled laborers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn1",
      "id": "ich2fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tcaption",
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "tab6"
    }
  }), _vm._v("TABLE 6")]), _vm._v(" "), _c('p', {
    staticClass: "tcaption1"
  }, [_vm._v("MALES AND FEMALES OVER TEN ENGAGED IN SELECTED OCCUPATIONS CHICAGO, 1900")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0030-01.jpg",
      "width": "87%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0031-01.jpg",
      "width": "87%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_vm._v("SOURCE: "), _c('em', [_vm._v("U.S. Twelfth Census")]), _vm._v(", 1900, "), _c('em', [_vm._v("Special Reports: Occupations")]), _vm._v(", pp. 516–23.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_c('sup', [_vm._v("a")]), _vm._v(" Includes porters in stores.")]), _vm._v(" "), _c('p', {
    staticClass: "tsource"
  }, [_c('sup', [_vm._v("b")]), _vm._v(" Includes elevator operators, longshoremen, and unskilled workers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Negroes entered occupations that were not desirable enough to be contested by whites. When white workers sought jobs in trades dominated by Negroes, they were usually able to drive the Negroes out. In the nineteenth century, for instance, many Negroes had worked as barbers and coachmen, but by the early twentieth century, whites had replaced most of them in these capacities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn2",
      "id": "ich2fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Hence Negroes “were constantly driven to lower kinds of occupations which are gradually being discarded by the white man.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn3",
      "id": "ich2fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" These jobs were generally low-paying, carried the stigma of servility, and offered few opportunities for advancement. Porters in hotels, stores, and railroads, and janitors in apartment buildings and business houses had no chance to move up to better positions because these concerns hired Negroes in no other capacities. Among the service trade employees, only waiters could look forward to promotions; the job of headwaiter, which paid as much as one hundred dollars a month, was perhaps the most lucrative to which Negroes could aspire."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn4",
      "id": "ich2fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Negro women were particularly limited in their search for desirable positions. Clerical work was practically closed to them and only a few could qualify as school teachers. Negro domestics often received less than white women for the same work, and they could rarely rise to the position of head servant in large households—a place traditionally held by a Swedish woman."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn5",
      "id": "ich2fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "tcaption",
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "tab7"
    }
  }), _vm._v("TABLE 7")]), _vm._v(" "), _c('p', {
    staticClass: "tcaption1"
  }, [_vm._v("MALES AND FEMALES OVER TEN ENGAGED IN SELECTED OCCUPATIONS CHICAGO, 1910")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0032-01.jpg",
      "width": "68%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0033-01.jpg",
      "width": "68%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_vm._v("SOURCE: "), _c('em', [_vm._v("U.S. Thirteenth Census")]), _vm._v(", 1910, vol. 4, "), _c('em', [_vm._v("Population: Occupation Statistics")]), _vm._v(", pp. 544–47.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_vm._v("NOTE: The 1910 census report does not provide subtotals for Negro workers. The table accounts for 92.6 per cent of Negro male employees and 92.4 per cent of Negro female employees.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_c('sup', [_vm._v("a")]), _vm._v(" Includes officials, foremen, apprentices.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_c('sup', [_vm._v("b")]), _vm._v(" Includes road building, steam and street railway laborers.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_c('sup', [_vm._v("c")]), _vm._v(" These classifications undoubtedly overlap.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_c('sup', [_vm._v("d")]), _vm._v(" Includes laborers in coal and lumber yards, stores; includes porters in stores.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_c('sup', [_vm._v("e")]), _vm._v(" Policemen, firemen, guards, watchmen, officials, public service laborers.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_c('sup', [_vm._v("f")]), _vm._v(" Not including porters in stores.")]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_c('sup', [_vm._v("g")]), _vm._v(" Not in factories.")]), _vm._v(" "), _c('p', {
    staticClass: "tsource"
  }, [_c('sup', [_vm._v("h")]), _vm._v(" Not in laundries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("Several factors combined to keep Negroes out of industry and trade—especially the skilled and semiskilled jobs. First, most employers were simply disposed against hiring Negroes so long as an adequate supply of white labor was available—and with open immigration from Europe there was seldom a labor shortage. These employers feared that their white employees would object to working with Negroes, and many believed that Negro workers were less efficient."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn6",
      "id": "ich2fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Secondly, many Negroes with skills had acquired them in the South and were often unable to meet Northern standards. Moreover, they were seldom able to acquire skills in the North: apprentice programs were usually open to whites only, and Negroes had little desire to learn a trade so long as its job prospects remained uncertain."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn7",
      "id": "ich2fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Finally, the refusal of most trade unions to admit black workers on an equal basis kept Negroes out "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("of many trades. Some unions completely excluded Negroes through clauses in their constitutions; others admitted Negroes, but then either segregated them in separate, subordinate locals, excluded them from specific projects, or simply made no effort to find jobs for them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn8",
      "id": "ich2fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Civil service jobs were theoretically open to all without discrimination. State law required competitive examinations and appointment on the basis of merit for a wide range of municipal jobs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn9",
      "id": "ich2fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Yet, in 1910, only 224 or 1.5 per cent of the public service jobs were held by Negroes; by 1913, Negroes held 1.9 per cent of these positions, but this figure was still lower than the proportion of Negroes in the total work force."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn10",
      "id": "ich2fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" The inability of many Negroes, especially recent migrants from the South, to compete successfully on the examinations partially explains this lag. But, despite the law, personal prejudice also played a part. Appointing officers found numerous devices to circumvent legal regulations: they held examinations infrequently, filled vacancies with temporary appointments that were repeatedly renewed, and showed favoritism in the examining process. As one Negro employee explained, “Civil Service is run by friendship . . . and under that sort of arrangement, Negroes won’t come out on top.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn11",
      "id": "ich2fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" One Negro, certified for a civil service job in 1906, told how a head clerk exerted pressure and coercion to persuade him that the job would not satisfy him."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn12",
      "id": "ich2fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Once appointed, Negroes often faced segregated working conditions and discrimination in promotion. This was most flagrant in the fire department, which openly maintained Jim Crow units until the 1930’s."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn13",
      "id": "ich2fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" In other departments, Negroes rarely advanced beyond menial positions. An exception was the police department where, at the onset of World War I, there were about fifty Negro officers. But most Negro policemen were assigned only "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("to Negro neighborhoods and few could aspire to become sergeants, lieutenants, or detectives."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn14",
      "id": "ich2fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the postal service, where similar civil service regulations applied, Negroes fared better. By 1910, over five hundred Negroes worked in the Chicago Post Office."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn15",
      "id": "ich2fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Negroes rarely complained of discrimination in securing postal jobs. This was primarily the result of Congressman Martin Madden’s position on the House of Representatives Post Office Committee. Even during the Wilson administration, when the federal government sought to reduce the number of Negroes in the postal service, Madden, who represented a predominantly Negro district on Chicago’s South Side, protected his Negro constituents."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn16",
      "id": "ich2fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Promotions, however, which depended only upon the discretion of the postmaster, came slowly; only two Negroes held supervisory positions before the War."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn17",
      "id": "ich2fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Nevertheless, the postal service provided Negroes with almost their only opportunity for clerical work and carried considerable prestige among Chicago Negroes. Several post office clerks became community leaders, and an organization of Negro postal employees, the Phalanx Forum, was a major political and social force in prewar Black Chicago."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn18",
      "id": "ich2fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only opportunity Negroes had to enter basic trades in early twentieth-century Chicago was as strikebreakers. The use of Negro scab labor heightened anti-Negro feeling in the city and left a legacy of bitterness and distrust between white and black workers. In the 1904 stockyards strike and the 1905 teamsters strike, the importation of non-union Negro labor set off the most serious racial conflicts of the prewar period.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The use of scabs to break strikes was nothing new in the meatpacking industry, but the 1904 strike was the first in which Negroes played a major role in crushing the union. From the packers’ point of view, Negroes were ideal strikebreakers. They generally had no scruples about working as scabs: those brought in from "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("the South were almost totally ignorant of the principles of trade unionism, while those who had had experience with unions had generally found them discriminatory. Moreover, the importation of Negroes in large numbers created panic and fear within union ranks."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn19",
      "id": "ich2fn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout the summer of 1904, as the strike wore on, the strikers focused their hostility upon the most visible symbol of their frustration—the Negro scabs. During the first weeks, as the packers announced the gradual resumption of operations with non-union men, the strikers began attacking the scabs as they entered the plants. Almost all of the victims were Negroes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn20",
      "id": "ich2fn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The most serious incident occurred when a mob, estimated at between two and five thousand, stoned two hundred Negroes who, with police protection, were attempting to leave the Hammond Company packing plant."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn21",
      "id": "ich2fn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" The packers then set up makeshift housing for the workers within the plants, and trainloads of Negro laborers poured in from the South. Relatively few local Negroes were employed; the companies instead sent agents south to lure workers to Chicago with the prospect of $2.25-a-day wages plus room and board. The strikers and their sympathizers characterized the Southern workers as “big, ignorant, vicious Negroes, picked up from the criminal elements of the black belts of the country.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn22",
      "id": "ich2fn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" The antipathy toward the importation of Southern Negroes helped create support for the union cause. The Ashland Avenue Business Men’s Association, for instance, protested to the mayor about the strikebreakers: “These men and women,” the group stated, “are a menace to the city of Chicago; for to any responsible man it is plain that such people cannot permanently be retained by the trust and hence must be poured out upon the city at the beginning of the winter season; they are a menace as future paupers.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn23",
      "id": "ich2fn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, the strikebreakers proved to be an effective weapon. "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("The industry was sufficiently mechanized to allow the packers to increase their operations to nearly full capacity while using unskilled scab labor. A few Negroes, to be sure, deserted the packers. A union man, for example, who boarded a labor train as it entered the city, persuaded a hundred Negroes from Cincinnati to leave their jobs before they had even begun work."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn24",
      "id": "ich2fn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" And two days later, three hundred Negroes left the Armour and Morris plants, protesting they could not cash their paychecks because of the tense conditions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn25",
      "id": "ich2fn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" But most of the strikebreakers remained loyal and provided the packers with the tool that they needed to defeat the union."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn26",
      "id": "ich2fn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Negroes made few permanent gains as a result of the strike. While the Poles, who had first entered the stockyards as strikebreakers in 1886, remained to form an important segment of the labor force, most of the Negro workers were discharged once the strike was settled."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn27",
      "id": "ich2fn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Although an estimated two thousand Negroes were hired by the packers during the strike, by 1910 only 365 of the 16,367 workers classified by the census as stockyards and packinghouse operatives were Negroes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn28",
      "id": "ich2fn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" The strike did, however, induce the union to take greater cognizance of Negro workers. The Amalgamated Meat Cutters and Butcher Workmen admitted those Negroes who remained in the yards, and by the time the packers began to employ large numbers of black workers, it had become one of the few large unions to welcome Negroes as members."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn29",
      "id": "ich2fn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" But the major legacy of the strike was an intensified anti-Negro "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("sentiment on the part of white Chicagoans. Ben Tillman, speaking in Chicago shortly after the end of the strike, reminded a stockyards district audience of something they would not soon forget. “It was the niggers,” he said, “that whipped you in line. They were the club with which your brains were beaten out.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn30",
      "id": "ich2fn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eight months after the stockyards union surrendered, Chicago found itself in the grips of the most violent labor disturbance since the Pullman strike of 1894. In April, 1905, the Teamsters Union called a sympathy strike at Montgomery Ward’s—in support of a group of striking garment workers. The owners of the major downtown department stores charged the union with breach of contract, announced that they would not renew their union contracts when they expired, and vowed a war of extermination against the teamsters. By the end of the month, the strike had spread to every leading employer in Chicago. Business came to a virtual standstill and pitched battles, claiming as many as a hundred casualties in a single day, raged throughout the city."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn31",
      "id": "ich2fn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("On the first of May, the merchants brought in a trainload of Negro teamsters under the leadership of a professional strikebreaker. As in the case of the stockyards strike, the importation of Negroes created widespread alarm. The appearance of a Negro driver on the streets of Chicago signaled violent attacks and rioting."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn32",
      "id": "ich2fn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" The city council asked the corporation counsel for an opinion “as to whether the importation of hundreds of Negro laborers is not a menace to the community and should not be restricted.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn33",
      "id": "ich2fn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Local Negroes, too, objected to the importation of strikebreakers. The "), _c('em', [_vm._v("Broad Ax")]), _vm._v(", a Negro weekly, said that the employers")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("are not justified in bringing hundreds and hundreds of colored men here from the remote parts of the South—many of them representing the lowest and toughest element of the race . . . to temporarily serve as strikebreakers for such Negro-hating concerns as Marshall Field and Company, Mandel Brothers and Montgomery Ward and Company, who have no use for Negroes in general except to use them as brutish clubs to beat their white help over the head. . . . The presence of "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("this class of Negro in Chicago at the present time makes it much more difficult for the respectable colored people in this community to get along."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn34",
      "id": "ich2fn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The employers’ association finally agreed to stop bringing in Negro teamsters from outside the city, but refused to discharge strikebreakers and continued to hire local Negroes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn35",
      "id": "ich2fn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unlike the stockyards strike, when anti-Negro violence was generally confined to attacks on actual strikebreakers, the teamsters strike brought Chicago to the brink of a race riot. Hostility toward Negro scabs was easily translated into general antipathy toward Negroes. Several Negro leaders, alarmed by the rising tide of anti-Negro feeling, protested police brutality toward Negroes and condemned the daily newspapers for “the hostile attitude they have assumed against all Afro-Americans” during the strike."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn36",
      "id": "ich2fn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Nowhere in the city was hostility toward Negroes more intense than in the working-class neighborhood just west of the black belt. Every day, the residents—many of them striking teamsters–saw Negroes driving the wagons of the nearby Peabody Coal Company. Then, on May 16, a Negro shot and killed an eight-year-old boy who had shouted insults at him as he passed through the streets. During the following week, hysteria gripped the neighborhood. Negroes were dragged from streetcars and beaten, and even heavy police guards, posted throughout the area, could not protect Negroes from white attacks. The climax came on May 21 when a white bartender shot a Negro to death in a saloon brawl. Negroes retaliated and in the course of the day, two people were killed and twelve were injured. It was the bloodiest racial conflict in the city before the riot of 1919."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn37",
      "id": "ich2fn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The merchants, like the packers, used Negro workers to serve their purposes and then discharged them. The census reported fewer Negro teamsters in 1910 than in 1900."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn38",
      "id": "ich2fn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Not until Chicago’s major employers found themselves confronted with a real labor shortage were Negroes able to gain a foothold in the basic industries and trades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Negro’s status in the job market, then, differed widely from "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("that of most white ethnic minorities. Excluded from the major industries where the possibility of decent wages and advancement was greatest, Negroes had little chance to escape poverty. European immigrants secured steady jobs in the stockyards or steel mills and could advance to skilled or supervisory capacities; their sons entered clerical and managerial occupations. But as porters and servants and janitors who entered industry only to serve as the unwitting tools of beleaguered employers, Negroes had few such opportunities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The law prohibited racial discrimination in public accommodations, municipal services, and schools in Chicago and prescribed punishments for violators. The Illinois Civil Rights Law, enacted in 1885, provided “that all persons . . . shall be entitled to the full and equal enjoyment of the accommodations, advantages, facilities and privileges of inns, restaurants, eating houses, barber shops, theatres, and public conveyances on land and water . . . and all other public accommodations.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn39",
      "id": "ich2fn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" When the state supreme court held in 1896 that the last clause was too vague to be enforced,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn40",
      "id": "ich2fn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" the legislature promptly amended the law to cover explicitly hotels, soda fountains, saloons, bathrooms, skating rinks, concerts, cafés, bicycle rinks, elevators, ice cream parlors, railroads, omnibuses, stages, streetcars, and boats."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn41",
      "id": "ich2fn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Violation of the law could result in forfeiture of from $25 to $500 to be paid to the aggrieved party, plus a fine of up to $500 and imprisonment of up to one year."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn42",
      "id": "ich2fn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the law and the city’s official color blindness in providing municipal services, numerous incidents testified to a persistent, although not rigid, pattern of discrimination in these areas. A Negro could never be certain of what awaited him when he entered a store, restaurant, saloon, or hotel outside of the black belt. Most "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("proprietors would accommodate a Negro if they thought refusal would create a major controversy; Booker T. Washington, for instance, stayed regularly at the plush Palmer House when he visited Chicago."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn43",
      "id": "ich2fn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" But less prominent Negroes were often harassed or simply refused service in downtown establishments. The La Salle Hotel turned away a luncheon meeting of one thousand clubwomen because their number included several Negro members."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn44",
      "id": "ich2fn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Many theaters seated Negroes only in the balcony, and bartenders frequently refused to serve Negro patrons."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn45",
      "id": "ich2fn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" In 1913, a theater opened on the very edge of the black belt and announced that Negroes would not be seated on the main floor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn46",
      "id": "ich2fn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Leading department stores were also wont to discriminate, but their policy was erratic. Negroes frequently complained of discourteous treatment at Marshall Field’s, but in one incident when a prominent Negro woman spoke to the manager about such treatment, the salesperson involved was immediately discharged."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn47",
      "id": "ich2fn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the state civil rights law seemed explicitly to forbid discriminatory practices, it was difficult to obtain a conviction under it. In 1905, a jury refused to award damages to a Negro politician who was denied service at a bar, and a 1910 jury decided in favor of a theater that had turned down a Negro who was trying to buy tickets for the main floor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn48",
      "id": "ich2fn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Even when Negroes won such suits, the punishment was often minimal: one bartender found guilty of violating the civil rights law was fined $5 and costs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn49",
      "id": "ich2fn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Businessmen not covered by the civil rights law could discriminate more openly. An osteopath on the edge of the black belt displayed a sign reading “white patients only,” and a cemetery ran a display advertisement announcing that their grounds “are exclusively for the white race.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn50",
      "id": "ich2fn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Another form of discrimination—analogous "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("to that found in the housing field—was the practice of charging Negroes higher prices. This was widespread in the insurance business. While some companies refused to sell life insurance policies to Negroes, others offered policies to Negroes at higher premiums, arguing that this was necessary because of their higher death rate."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn51",
      "id": "ich2fn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Price differentials were so common in the cemetery business that, in 1911, Edward Green, a Negro member of the state legislature, secured passage of an amendment to the civil rights law forbidding discriminatory rates in the sale of cemetery plots."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn52",
      "id": "ich2fn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Official city agencies never, of course, openly admitted discriminatory practices. There were, however, persistent charges that a “color line” was drawn in the Cook County Jail. The "), _c('em', [_vm._v("Broad Ax")]), _vm._v(" maintained that “white and black prisoners are kept apart as much as possible,” and the "), _c('em', [_vm._v("Defender")]), _vm._v(" insisted that Negro inmates were allowed to exercise in the bullpen only when whites were not there and that meal service was segregated."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn53",
      "id": "ich2fn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Publicly supported hospitals were also charged with discrimination. The Cook County Hospital, while admitting Negro patients, refused to hire Negro nurses, arguing that “white nurses refuse to work with colored.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn54",
      "id": "ich2fn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" The director of the Hospital for Contagious Diseases, a branch of the county hospital, maintained privately that white patients would walk out if placed in the same room with Negroes and that the idea of having Negro nurses for white patients was “absolutely impossible.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn55",
      "id": "ich2fn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" “You see,” said Celia Parker Woolley, a prominent white progressive, “how far it is from being true that segregation could never be practiced in institutions supported by public money.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn56",
      "id": "ich2fn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("The police and the courts were also charged with hostility toward Negroes. The strike disturbances of 1904 and 1905 gave rise to numerous charges of discrimination. A decade later, Louise De Koven Bowen, a white reform leader, stated that Negroes were frequently arrested “on charges too flimsy to hold a white man” and were often “convicted on inadequate evidence.” She cited the case of one George W., a nineteen-year-old Negro arrested for rape in 1912. The police, she said, beat and kicked George until he confessed, and his lawyer advised him to plead guilty even when he insisted on his innocence. Although the judge referred to the evidence as flimsy in his instructions to the jury, the youth was found guilty and sentenced to fourteen years in prison. One witness, asked why he had not been more explicit in his testimony in the defendant’s behalf, reportedly answered, “Oh well, he’s only a nigger anyway.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn57",
      "id": "ich2fn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" The police were also criticized for their attitude toward prostitutes and saloons. Not only was the segregated vice district always located in the black belt, but, according to the "), _c('em', [_vm._v("Tribune")]), _vm._v(", the police raided so-called “black and tan resorts” because they were frequented by an interracial clientele. The police chief allegedly ordered that “colored saloonkeepers must keep white men out of their saloons and that white saloonkeepers are to prevent colored men from entering their places of business.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn58",
      "id": "ich2fn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The public school system had been legally integrated since 1874, but here, too, there were frequent instances of discrimination and interracial friction after 1890. Much of it came from white students and their parents rather than from school officials. Changes in school boundary lines or pupil transfers, resulting in newly integrated schools, often led to white protests. In 1905, a group of white children rioted when they were transferred to a predominantly Negro school, and in 1908, over one hundred and fifty students stayed home when they were transferred to a school attended by Negroes. A year later, two Negro children, enrolling in a previously all-white school, were insulted and beaten by their classmates."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn59",
      "id": "ich2fn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Wendell Phillips High School, the city’s first predominantly "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("Negro high school, was the scene of frequent racial conflicts. In 1912, for instance, several white students attacked a Negro boy who had allegedly insulted a white girl: the resulting melee was described by the "), _c('em', [_vm._v("Tribune")]), _vm._v(" as a “miniature race war.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn60",
      "id": "ich2fn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" School officials frowned upon these manifestations of white hostility. After the 1908 “school strike,” the president of the board of education commented, “a clean colored boy is, in my opinion, far better than a dirty white boy. . . . The parents of some of the colored children who attend the Keith School are far above parents of some of the white children there.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn61",
      "id": "ich2fn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" But the board was forced to acknowledge that the “color line is a source of continual strife.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn62",
      "id": "ich2fn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("White groups asked periodically for formal segregation of the Chicago school system. Between 1900 and 1915, such proposals were discussed openly in the press and at school board meetings, causing sufficient alarm to induce Negro leaders to lodge formal protests against any possible public school segregation. In 1906, reports that whites would attempt to insert a clause in the new city charter, permitting segregated schools, aroused Negro leaders to conduct a successful campaign to place a Negro on the charter commission."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn63",
      "id": "ich2fn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Four years later, the Southern Society of Chicago urged Negroes to join them in supporting separate schools, emphasizing the greater opportunity this would provide for Negro teachers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn64",
      "id": "ich2fn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" The Hyde Park Improvement Protective Club, which had suggested the desirability of separate schools during the 1909 housing quarrel, continued to campaign for this policy. In 1912, it petitioned the mayor in favor of segregation and held a meeting to discuss the proposal."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn65",
      "id": "ich2fn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" But few responsible Chicagoans seriously entertained these suggestions. School superintendent Ella Flagg Young, a friend of John Dewey and Jane Addams and a prominent member of Chicago’s progressive intellectual circle, persistently quashed any attempt at discrimination. When, for instance, Wendell Phillips High School set up separate social activities for white and Negro students in 1915, Mrs. Young declared that "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("if the school continued this policy, all social affairs would be canceled."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn66",
      "id": "ich2fn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Private educational and social welfare institutions developed widely varying policies, but few were completely free of discrimination. The University of Chicago and Northwestern University admitted Negroes without apparent discrimination, but both institutions experienced minor disturbances when Negro students entered the dormitories."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn67",
      "id": "ich2fn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Catholic parochial schools, on the other hand, were openly segregated: all Negro students attended St. Monica’s School."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn68",
      "id": "ich2fn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" Most private welfare institutions were closed to Negroes. Only after vigorous protest from Negro leaders did the Juvenile Protective Association admit Negroes to its Hyde Park center."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn69",
      "id": "ich2fn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" When a small Negro orphanage closed its doors in 1913, the officials of the white Park Ridge School helped transfer them to another Negro home, but strongly resisted the suggestion that they be admitted to Park Ridge. “These girls,” wrote a Park Ridge official privately, “when put with or even "), _c('em', [_vm._v("near")]), _vm._v(" the same class of white girls . . . exercise a very deleterious influence on each other.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn70",
      "id": "ich2fn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Although Negroes had participated in the activities of the Young Men’s Christian Association in the late nineteenth century, they met mounting discrimination after 1900. By 1910, they found themselves completely shut out of the white YMCA, and as a result, the all-Negro Wabash Avenue YMCA was opened in 1913."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn71",
      "id": "ich2fn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Ida Wells-Barnett, a prominent Negro civic leader, described the plight of Negroes, barred from white social agencies:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("While every other class is welcome in the Y.M.C.A. dormitories, Y.W.C.A. homes, the Salvation Army and the Mills hotels, not one of these will give a negro a bed to sleep in or permit him to use their reading rooms and gymnasiums. Even the Women’s Model Lodging House announces that it will give all women accommodations who need a place to sleep except drunkards, immoral women and negro women. What, then, is the negro to do? Those of us who realize the condition of this great, idle, proscribed class and view with pain and shame this increasing criminal record have absolutely no money to use in helping to change these conditions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn72",
      "id": "ich2fn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Although race relations before World War I were peaceful by 1919 standards, an ominous, if muted, current of racial violence was manifest. The stockyards and teamsters strikes and the disputes over housing occasioned the most serious outbreaks, but they were not the only ones. Negro criminals—or suspected criminals—were frequently threatened by lynch mobs. In 1900, a crowd of angry whites stoned a Clark Street building in an attempt to capture a Negro who had been arrested for attacking a seven-year-old white girl."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn73",
      "id": "ich2fn73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" On another occasion, five thousand whites left a sandlot baseball game to chase six Negroes who were fighting with white men. Four of the Negroes were arrested, and the mob, shouting “lynch them,” then tried unsuccessfully to wrest them from the police."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn74",
      "id": "ich2fn74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_46a"
    }
  }), _c('a', {
    attrs: {
      "id": "pla1"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An oil painting (by Aaron E. Darling, about 1865) of John Jones, the undisputed leader of Chicago’s Negro community until his death in 1879.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "pla2"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Robert S. Abbott, who built the "), _c('em', [_vm._v("Chicago Defender")]), _vm._v(" into the most important Negro newspaper in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46b"
    }
  }), _c('a', {
    attrs: {
      "id": "pla3"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "pla4"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Ferdinand and Ida Barnett, prominent members of the militant wing of Chicago’s Negro leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46c"
    }
  }), _c('a', {
    attrs: {
      "id": "pla5"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig5.jpg",
      "width": "90%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Olivet Baptist church in 1904-5, housing the largest Negro congregation in Chicago.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46d"
    }
  }), _c('a', {
    attrs: {
      "id": "pla6"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Robert Mott’s theater cafe about 1920. The Pekin featured a lively fare of ragtime, cakewalks, and “coon” songs.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "pla7"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A packinghouse official leads a group of Negro women strikebreakers into a plant during the 1904 strike.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46e"
    }
  }), _c('a', {
    attrs: {
      "id": "pla8"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig8.jpg",
      "width": "87%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Negro strikebreakers at Swift & Company during the 1904 stockyards strike.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46f"
    }
  }), _c('a', {
    attrs: {
      "id": "pla9"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A rear view, taken about 1920, of tenements on Federal Street, in the heart of the Negro slum.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46g"
    }
  }), _c('a', {
    attrs: {
      "id": "pla10"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Homes owned by middle-class Negroes on South Park Boulevard, about 1920.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46h"
    }
  }), _c('a', {
    attrs: {
      "id": "pla11"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Negro family, just arrived in Chicago from the South, during the World War I migration.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46i"
    }
  }), _c('a', {
    attrs: {
      "id": "pla12"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Alderman Oscar DePriest posts bond after being charged with bribery in 1917.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46j"
    }
  }), _c('a', {
    attrs: {
      "id": "pla13"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "pla14"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46k"
    }
  }), _c('a', {
    attrs: {
      "id": "pla15"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("During the 1919 race riots, a white mob chases a Negro into his home—and then stones him to death with bricks. He is dead by the time the police arrive.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_46l"
    }
  }), _c('a', {
    attrs: {
      "id": "pla16"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A policeman escorts a Negro couple to safety during the 1919 race riots.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "pla17"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/fig17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("The state militia stands guard in the black belt, after the 1919 riots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("More serious was the wave of violence that came in the wake of the 1908 Springfield race riot. News of racial warfare in the state capital inspired many Chicago whites to attack Negroes. A mob attempted to lynch two Negro murder suspects, even though the victims, in both cases, were also Negroes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn75",
      "id": "ich2fn75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Violence erupted on a Chicago River dock, where several white laborers declared that they would leave their jobs unless their Negro coworkers were fired."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn76",
      "id": "ich2fn76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" For several weeks, armed posses hunted Negroes who were supposed fugitives from Springfield and, in at least two cases, planned lynchings."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn77",
      "id": "ich2fn77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" The police, however, took special measures to prevent a general outbreak. The authorities mobilized special mounted forces and drill squads, and police "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("officers were ordered to intervene quickly in any quarrels between Negroes and whites. With the cooperation of Negro leaders, who organized a law and order league on the South Side, a major riot was averted."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn78",
      "id": "ich2fn78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Most observers—both Negro and white—agreed that the status of Negroes in Chicago was deteriorating, and some saw parallels between developments in Chicago and the hardening of Jim Crow patterns in the South. Two white commentators noted that “in the face of increasing manifestations of race prejudice, the Negro has come to acquiesce silently as various civil rights are with-held him in the old ‘free North.’"), _c('span', {
    staticClass: "sfs"
  }), _vm._v("”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn79",
      "id": "ich2fn79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" A Negro columnist, in 1914, took an even more pessimistic position. He noted that “Afro-American people in increasing numbers are refused the accommodations of public places . . . in . . . violation of the laws of the state of Illinois,” that “discrimination is manifesting itself more and more in the courts of Chicago,” and that “the police department is especially filled with the wicked and unlawful determination to degrade Afro-Americans and fix upon them the badge of inferiority.” He concluded that Negroes “are more and more being reduced to a fixed status of social and political inferiority.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn80",
      "id": "ich2fn80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To compare the evolution of the Negro’s status in Chicago with the crystallization of the caste system in the South during the same period was an exaggeration. Discrimination in Chicago remained unofficial, informal, and uncertain; the Negro’s status did not become fixed. Nevertheless, as Negroes became more numerous and conspicuous, white hostility increased and Negroes encountered an ever more pervasive pattern of exclusion. Edward E. Wilson, a Negro attorney, noted that the growth of the Negro community “brought [Negroes] into contact with whites who hardly knew that there were a thousand Colored people in Chicago.” Moreover, “Colored children have appeared in numbers in many schools,” and “Colored men have pushed their way into many employments.” “All these things,” he concluded, “have a tendency to cause the whites to resort to jim crow tactics.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch2fn81",
      "id": "ich2fn81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("By 1915, Negroes had become a special group in the social structure of prewar Chicago. They could not be classified as merely another of Chicago’s many ethnic groups. The systematic proscription they suffered in housing and jobs, the discrimination they often—although not always—experienced in public accommodations and even municipal services, the violence of which they were frequently victims, set them apart from the mainstream of Chicago life in significant ways. They were forced to work out their destiny within the context of an increasingly biracial society.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ec2100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226160702_13_ch2.vue
// module id = 93
// module chunks = 0